"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVis = require("react-vis");

var _CustomerGradient = _interopRequireDefault(require("./CustomerGradient"));

var _colors = require("./colors");

var _chartStyles = require("./chartStyles");

var _chartDataTypes = require("../../constants/chartDataTypes");

var _chartDisplayTypes = require("../../constants/chartDisplayTypes");

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CustomerDisplay = function CustomerDisplay(_ref) {
  var chartType = _ref.chartType,
      productionCoordinates = _ref.productionCoordinates,
      consumptionCoordinates = _ref.consumptionCoordinates,
      expectedCoordinates = _ref.expectedCoordinates,
      batteryCoordinates = _ref.batteryCoordinates,
      enabledDataTypes = _ref.enabledDataTypes,
      hasNoData = _ref.hasNoData,
      renderXAxisTick = _ref.renderXAxisTick,
      roundedMaxValue = _ref.roundedMaxValue,
      tickValues = _ref.tickValues;
  var hasProduction = enabledDataTypes.indexOf(_chartDataTypes.PRODUCTION) > -1;
  var hasConsumption = enabledDataTypes.indexOf(_chartDataTypes.CONSUMPTION) > -1;
  var hasBattery = enabledDataTypes.indexOf(_chartDataTypes.BATTERY) > -1;
  var hasExpected = enabledDataTypes.indexOf(_chartDataTypes.EXPECTED) > -1;
  return /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    margin: {
      left: 0,
      right: 0,
      bottom: 60,
      top: 60
    },
    xType: "ordinal",
    yDomain: [0, roundedMaxValue]
  }, /*#__PURE__*/_react["default"].createElement(_CustomerGradient["default"], {
    id: "customerDailyGradient"
  }), !hasNoData && /*#__PURE__*/_react["default"].createElement(_reactVis.HorizontalGridLines, {
    tickValues: tickValues
  }), chartType === _chartDisplayTypes.BAR && hasProduction && /*#__PURE__*/_react["default"].createElement(_reactVis.VerticalBarSeries, {
    barWidth: 0.4,
    color: _colors.START_GRADIENT,
    data: productionCoordinates
  }), chartType === _chartDisplayTypes.LINE && hasProduction && /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    color: _colors.START_GRADIENT,
    data: productionCoordinates,
    style: {
      strokeWidth: 3
    }
  }), chartType === _chartDisplayTypes.BAR && hasConsumption && /*#__PURE__*/_react["default"].createElement(_reactVis.VerticalBarSeries, {
    barWidth: 0.4,
    color: _colors.CUSTOMER_CONSUMPTION,
    data: consumptionCoordinates
  }), chartType === _chartDisplayTypes.LINE && hasConsumption && /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    color: _colors.CUSTOMER_CONSUMPTION,
    data: consumptionCoordinates,
    style: {
      strokeWidth: 3
    }
  }), chartType === _chartDisplayTypes.BAR && hasBattery && /*#__PURE__*/_react["default"].createElement(_reactVis.VerticalBarSeries, {
    barWidth: 0.4,
    color: _colors.BATTERY,
    data: batteryCoordinates
  }), chartType === _chartDisplayTypes.LINE && hasBattery && /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    color: _colors.BATTERY,
    data: batteryCoordinates,
    style: {
      strokeWidth: 3
    }
  }), hasExpected && /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    color: _colors.START_GRADIENT,
    data: expectedCoordinates,
    style: {
      strokeWidth: 3,
      strokeDasharray: 6
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.Borders, {
    style: _chartStyles.borderStyle
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.XAxis, {
    style: _chartStyles.xAxisStyle,
    tickFormat: renderXAxisTick
  }));
};

CustomerDisplay.propTypes = {
  batteryCoordinates: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  chartType: _propTypes["default"].oneOf([_chartDisplayTypes.LINE, _chartDisplayTypes.BAR]),
  consumptionCoordinates: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  enabledDataTypes: _propTypes["default"].arrayOf(_propTypes["default"].oneOf([_chartDataTypes.PRODUCTION, _chartDataTypes.CONSUMPTION])),
  expectedCoordinates: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  hasNoData: _propTypes["default"].bool,
  productionCoordinates: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  renderXAxisTick: _propTypes["default"].func.isRequired
};
CustomerDisplay.defaultProps = {
  batteryCoordinates: [],
  chartType: 'Bar',
  consumptionCoordinates: [],
  enabledDataTypes: [_chartDataTypes.PRODUCTION],
  expectedCoordinates: [],
  hasNoData: false,
  productionCoordinates: []
};
var _default = CustomerDisplay;
exports["default"] = _default;